// Speaking slot times use zero-padded HH:mm or HH:mm:ss.
export const endsAfterMidnight = (startTime: string, endTime: string): boolean =>
  endTime < startTime;
